export const healthdexAllowedDomain = [
    "gmail.com",
    "yahoo.com",
    "outlook.com",
    "hotmail.com",
    "singnet.com.sg",
    "yahoo.com.sg",
];